export async function downloadReport(url: string, filename: string, format: "csv" | "xlsx"): Promise<void> {
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) {
    let message = "Nie udało się pobrać eksportu.";
    try {
      const payload = await response.json();
      if (typeof payload?.error === "string") message = payload.error;
    } catch { /* Keep the readable fallback for non-JSON errors. */ }
    throw new Error(message);
  }
  const expectedType = format === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const contentType = (response.headers.get("content-type") ?? "").split(";", 1)[0]!.trim().toLowerCase();
  if (contentType !== expectedType) throw new Error("Serwer nie zwrócił pliku raportu.");
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const releaseObjectUrl = URL.revokeObjectURL.bind(URL);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.append(link);
  try { link.click(); } finally {
    link.remove();
    // Allow the browser to begin consuming the blob before releasing its URL.
    setTimeout(() => releaseObjectUrl(objectUrl), 1000);
  }
}
